<template>
    <el-dialog
            v-bind="$attrs"
            v-on="$listeners"
			:show-close="false"
            width="50%">
        <el-form :model="form" ref="form" class="demo-form-inline" label-width="100px">

            <el-form-item label="大类" class="h-elformWrap-3" prop="dalei" :rules="[
								  { required: true, message: '必须输入选项', trigger: 'blur'},
								]">
                <el-select v-model="form.dalei" filterable @change="handleItemChange1" placeholder="大类">
                    <el-option
                            v-for="item in list1"
                            :key="item.value"
                            :label="item.prodseries"
                            :value="item.oneLid">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="物料" class="h-elformWrap-3" >
                <el-select v-model="form.wuliao"
                           filterable
                           placeholder="物料">
                    <el-option
                            v-for="item in list2"
                            :key="item.value"
                            :label="`[${item.procategory}] [${item.prodcode}] ${item.promodel}`"
                            :value="item.prodcode">
                    </el-option>
                </el-select>
            </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="huidiao">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        name: "wuliaomiaoshuSelect",
        data() {
            return {
                form: {

                    dalei:'',
                    wuliao:'',

                },

                list1: [],
                list2: [],


                // props: {
                //     label: 'name',
                //     value: 'code',
                //     children: 'cities'
                // },

                query: {
                    pcode: 0,
                    oneLid: '',
                }
            }
        },

        props: {

        },

        created() {
            this.loadArea(1);
        },

        methods: {

            huidiao() {
                this.$refs['form'].validate((valid) => {

                    if (valid) {
                        this.form.daleiobj = _.find(this.list1,{oneLid:this.form.dalei});
                        this.form.wuliaoobj = _.find(this.list2,{prodcode:this.form.wuliao});
                        this.$emit('choseObj', this.form);
                    }

                });
            },

            loadArea(i) {
                ss.chanpin.idselectList(this.query).then(rd => {
                    this['list' + i] = rd;
                })
            },

            handleItemChange1(val) {
                this.query.pcode = null;
                this.query.oneLid = val;
                this.loadArea(2)

            },



        }
    }
</script>
